import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';
import mixins from '../../../styles/mixins';

export const useStyles = makeStyles<Theme>()((theme) => ({
  userPostsWrapper: {
    ...mixins.appSvg,
  },
  newPostWrapper: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    padding: 16,
    borderRadius: 4,
  },
  uploadedFilesWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    marginTop: '8px',
  },
  newPostData: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 16,
    '& svg': {
      marginTop: '8px',
      ...mixins.appSvg['& svg'],
    },
  },
  '& > div + div': {
    marginTop: 16,
  },

  '& > div:first-of-type': {
    marginTop: 0,
  },
  userPostsContainer: {},
}));
